import Registration from '@/store/modules/registration/constants';

export default {
  [Registration.mutationTypes.setEmailConfirmationLoading](state, loading) {
    const localState = state;

    localState.emailConfirmation.loading = loading;
  },
};
